// removed by extract-text-webpack-plugin
module.exports = {"messageWithAction":"_2UfxUN2_blnAbYPnZgy9wt","messageWithAction__message":"m08zVgs2riSITi-SZycIp"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/MessageWithAction/style.scss
// module id = 902
// module chunks = 0